export const seo = {
  title: "Posicionamiento SEO",
  headerTitle: "Puntaje SEO de tu tienda",
  headerDescription:
    "Mejora el posicionamiento de tus productos en Google optimizando título, slug y descripción.",
  tabs: {
    approved: "Optimizados ({{count}})",
    toImprove: "Por mejorar ({{count}})",
  },
  empty: {
    noProductsTitle: "Aún no tienes productos",
    noProductsDescription:
      "Crea productos para empezar a optimizar su posicionamiento SEO.",
    noProductsCta: "Crear producto",
    approvedEmpty: "No hay productos optimizados todavía",
    improveEmpty: "Todos tus productos están optimizados",
  },
  acquire: {
    title: "Activa el Posicionamiento SEO",
    description:
      "Optimiza tus productos para aparecer primero en las búsquedas de Google.",
    cta: "Adquirir complemento",
  },
  ai: {
    automaticWithAi: "Automático con IA",
    improveWithAi: "Mejorar con IA",
    improvingWithAi: "Mejorando con IA...",
    selectAll: "Seleccionar todos",
    cancel: "Cancelar",
    selectProductsError: "Selecciona al menos un producto para mejorar",
    improvementFailed: "No se pudo completar la mejora con IA",
    fieldButton: "IA",
    acquireTitle: "Activa Inteligencia Artificial",
    acquireDescription:
      "Genera metadatos SEO automáticamente y mejora varios productos a la vez.",
    predicting: "Generando con IA...",
    improvementSuccess: "Mejora con IA completada",
    jobInProgress:
      "Este producto se está mejorando con IA. Espera a que termine para editarlo.",
  },
  detail: {
    back: "Atrás",
    save: "Guardar",
    saving: "Guardando...",
    saveSuccess: "Metadatos SEO guardados correctamente",
    saveError: "No se pudieron guardar los metadatos SEO",
    loadError: "No se encontró el producto",
    fields: {
      targetKeyphrase: "Frase clave objetivo",
      targetKeyphraseHint: "Palabra o frase principal que describe el producto",
      seoTitle: "Título SEO",
      seoTitleHint: "Ideal entre 22 y 60 caracteres",
      slug: "Slug / URL amigable",
      slugHint: "Ideal entre 25 y 50 caracteres",
      metaDescription: "Meta descripción",
      metaDescriptionHint: "Ideal entre 100 y 150 caracteres",
    },
  },
  score: {
    label: "{{score}}/100",
  },
};
